import { get, post, put, del } from './client';
import type {
  IqServiceDetail,
  IqServiceListResponse,
  IqServiceTestResult,
  IqServiceServicesResponse,
  CreateIqServiceRequest,
  UpdateIqServiceRequest,
} from '@/types/iq-service';

export async function listIqServices(): Promise<IqServiceListResponse> {
  return get<IqServiceListResponse>('/admin/iq-services');
}

export async function getIqService(id: string): Promise<IqServiceDetail> {
  return get<IqServiceDetail>(`/admin/iq-services/${encodeURIComponent(id)}`);
}

export async function createIqService(data: CreateIqServiceRequest): Promise<IqServiceDetail> {
  return post<IqServiceDetail>('/admin/iq-services', data);
}

export async function updateIqService(id: string, data: UpdateIqServiceRequest): Promise<IqServiceDetail> {
  return put<IqServiceDetail>(`/admin/iq-services/${encodeURIComponent(id)}`, data);
}

export async function deleteIqService(id: string): Promise<void> {
  return del<void>(`/admin/iq-services/${encodeURIComponent(id)}`);
}

export async function testIqService(id: string): Promise<IqServiceTestResult> {
  return post<IqServiceTestResult>(`/admin/iq-services/${encodeURIComponent(id)}/test`);
}

export async function listIqServiceServices(id: string): Promise<IqServiceServicesResponse> {
  return get<IqServiceServicesResponse>(`/admin/iq-services/${encodeURIComponent(id)}/services`);
}
